/*
  Tweens the free-shipping fill between cart updates.

  Dawn re-renders the whole cart section on every change, so the bar is a brand
  new element each time and CSS alone can only animate it from 0. We remember the
  last percentage per placement and animate the fresh element from there.

  The animation is layered on top with the Web Animations API rather than by
  writing an inline width: the element's own CSS width is always the correct new
  value, so a throttled or failed animation leaves a right-sized bar, never a
  stuck one.
*/
class EbShippingBar extends HTMLElement {
  static lastPct = {};

  connectedCallback() {
    const fill = this.querySelector('.eb-shipping-bar__fill');
    if (!fill || !fill.animate) return;

    const key = this.dataset.context || 'default';
    const target = this.style.getPropertyValue('--eb-sb-pct').trim() || '0%';
    const from = EbShippingBar.lastPct[key];
    EbShippingBar.lastPct[key] = target;

    // Nothing to come from on first paint, and nothing to do if it didn't move.
    if (from === undefined || from === target) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const seconds = parseFloat(getComputedStyle(this).getPropertyValue('--eb-transition-slow'));
    fill.animate([{ width: from }, { width: target }], {
      duration: (seconds || 0.4) * 1000,
      easing: 'ease',
    });
  }
}

if (!customElements.get('eb-shipping-bar')) {
  customElements.define('eb-shipping-bar', EbShippingBar);
}
